var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 11,
    viewBox: "0 0 39 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54604 0.00178495C3.88862 -0.000264522 4.90677 -0.091964 5.33803 1.36356C5.62854 2.34401 6.09129 3.95004 6.7263 6.18165H6.98492C7.66591 3.82893 8.13371 2.2229 8.38833 1.36356C8.82409 -0.107126 9.91349 0.00181377 10.3492 0.00181377L13.7112 0.00181796V10.46H10.2846V4.29681H10.0548L8.14466 10.46H5.56656L3.65639 4.29224H3.42662V10.46H0V0.00181796L3.54604 0.00178495ZM18.6318 0.00181796V6.16958H18.9051L21.2287 1.09787C21.6797 0.0885888 22.641 0.00181796 22.641 0.00181796H25.957V10.46H22.4588V4.29224H22.1854L19.9074 9.36395C19.4564 10.3687 18.4495 10.46 18.4495 10.46H15.1336V0.00181796H18.6318ZM38.0482 4.97162C37.5603 6.35438 36.0279 7.34467 34.3313 7.34467H30.6628V10.46H27.3362V4.97162H38.0482Z",
    fill: "#0F754E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4933 0.00164795H27.1633C27.3378 2.33 29.3429 4.32321 31.4186 4.32321H38.2809C38.6769 2.38808 37.3137 0.00164795 34.4933 0.00164795Z",
    fill: "url(#paint0_linear_239_8831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_8831",
    x1: 38.3482,
    y1: 2.7201,
    x2: 27.1633,
    y2: 2.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.1165ddf89030f084875484919aa3cd49.svg";
export { ForwardRef as ReactComponent };